<template>
  <v-app>
    <v-main class="login-main">
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 rounded-xl pa-6">
              <v-card-title class="justify-center">
                <div class="text-center">
                  <v-img
                    src="/logo-salum.png"
                    alt="Salum Construcoes"
                    contain
                    max-height="63"
                    class="login-logo"
                  ></v-img>
                </div>
              </v-card-title>

              <v-card-text>
                <v-form ref="loginForm" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="username"
                    label="Usuário"
                    prepend-inner-icon="mdi-account"
                    outlined
                    dense
                    class="mb-4"
                    hide-details="auto"
                    :rules="
                      emailTocado
                        ? [
                            (v) => !!v || 'Informe o Login',
                            (v) => /.+@.+\..+/.test(v) || 'Email inválido',
                          ]
                        : []
                    "
                    @blur="
                      emailTocado = true;
                      $refs.loginForm.validate();
                    "
                  />

                  <v-text-field
                    v-model="password"
                    label="Senha"
                    prepend-inner-icon="mdi-lock"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                    outlined
                    dense
                    hide-details
                    class="mb-2"
                    :rules="[(v) => !!v || 'Informe a Senha']"
                    required
                  />

                  <div class="text-right mb-4">
                    <a
                      @click="esqueci"
                      class="text-decoration-none blue--text text--darken-2"
                      >ESQUECI A SENHA</a
                    >
                  </div>

                  <v-btn
                    color="primary"
                    class="white--text font-weight-bold"
                    block
                    large
                    :disabled="sending"
                    :loading="sending"
                    @click="login"
                  >
                    <v-icon left>mdi-lock-open</v-icon>
                    ENTRAR
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>

            <div
              class="text-center mt-6 grey--text text--darken-1 text-caption"
            >
              Powered by
              <a href="https://udumo.com.br" target="_blank">Udumo</a>
            </div>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="5000"
          >Usuario ou senha incorretos.
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { loginAsync, sendEmailChange } from "../services/loginService";

export default {
  name: "loginForm",
  data: () => ({
    valid: true,
    show1: false,
    username: null,
    password: null,
    sending: false,
    errorMessage: false,
    emailTocado: false,
  }),
  mounted() {
    let self = this;
    window.addEventListener("keyup", function (event) {
      if (event.keyCode === 13) {
        self.login();
      }
    });
  },
  methods: {
    async login() {
      if (this.sending) {
        return;
      }

      if (this.$refs.loginForm.validate()) {
        this.sending = true;

        try {
          const result = await loginAsync(this.username, this.password);
          if (!result.authenticated) {
            this.errorMessage = true;
            return;
          }
          this.$router.push("/");
          this.$store.dispatch("produto/atualizarListaProdutos").catch(() => {
            // A tela que usar produtos tentara carregar novamente em caso de falha.
          });
        } catch (e) {
          this.errorMessage = true;
        } finally {
          this.sending = false;
        }
      }
    },
    async esqueci() {
      this.$prompt(
        "Informe o email cadastrado",
        "",
        "Reenvio de senha",
        "question",
        {
          input: "email",
          confirmButtonText: "Enviar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: (r) => {
            return sendEmailChange(r);
          },
        }
      ).then((response) => {
        if (response.status) {
          this.$alert("", "Email enviado:", "success");
        } else {
          this.$alert(response.message, "Falha ao enviar o email:", "error");
        }
      });
    },
  },
};
</script>
<style scoped>
.login-main {
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  min-height: 100vh;
}

.login-logo {
  margin: 0 auto;
  max-width: 126px;
}
</style>
